import { Stack } from '@mantine/core';
import { SimpleSlider } from '@/app/components/shared/form/slider/SimpleSlider';
import { useFormContext } from '../../../contexts/formContext';
import { SettingTitle } from '../../../components/SettingTitle';

const path = 'assetSimplification.topologySettings.boundaryPreservationFactor';

const marks = [
  { value: 0, label: '0' },
  { value: 0.5, label: '0.5' },
  { value: 1, label: '1' },
];

export function BoundaryPreservation() {
  const form = useFormContext();

  return (
    <Stack gap='xs'>
      <SettingTitle
        title='Boundary Preservation'
        description='Choose how strongly mesh boundaries should be preserved. Stricter
        (higher) values require more boundary polygons'
      />
      <SimpleSlider min={0} max={1} step={0.1} marks={marks} w={400} {...form.getInputProps(path)} />
    </Stack>
  );
}
